// extracted by mini-css-extract-plugin
module.exports = {"circleMarker":"HotelsMap--circleMarker","circleMarkerInner":"HotelsMap--circleMarkerInner","circleMarkerFocused":"HotelsMap--circleMarkerFocused"};